import be from 'date-fns/locale/be';
import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import deAT from 'date-fns/locale/de-AT';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import fr from 'date-fns/locale/fr';
import frCH from 'date-fns/locale/fr-CH';
import hr from 'date-fns/locale/hr';
import it from 'date-fns/locale/it';
import nb from 'date-fns/locale/nb';
import nl from 'date-fns/locale/nl';
import pl from 'date-fns/locale/pl';
import sv from 'date-fns/locale/sv';
/**
 * Returns a date-fns locale object from an ISO 639 code
 */
export const getDateFNSLocale = (langauageCode) => dateFNSLocales[langauageCode] || enGB;
export const dateFNSLocales = {
    // German/Austria
    at: deAT,
    'de-AT': deAT,
    // French/Switzerland
    ch: frCH,
    'de-CH': frCH,
    // Belgium
    be: be,
    'nl-BE': be,
    // Danish
    da: da,
    'da-DK': da,
    // German
    de: de,
    'de-DE': de,
    // English/Great Britain
    en: enGB,
    'en-GB': enGB,
    // English/United States
    us: enUS,
    'en-US': enUS,
    // Spanish
    es: es,
    'es-ES': es,
    // French
    fr: fr,
    'fr-FR': fr,
    // Croatian
    hr: hr,
    'hr-HR': hr,
    // Italian
    it: it,
    'it-IT': it,
    // Dutch
    nl: nl,
    'nl-NL': nl,
    // Norwegian
    no: nb,
    nn: nb,
    'no-NO': nb,
    'nn-NO': nb,
    // Polish
    pl: pl,
    'pl-PL': pl,
    // Swedish
    se: sv,
    sv: sv,
    'se-SE': sv,
    'sv-SE': sv,
};
//# sourceMappingURL=react.locales.js.map